import { getHardwareService } from "@ntconnect/framework/pbx";

export const fetchHardware = (status, page, pageSize, search, filter) =>
  getHardwareService().fetchHardware(status, page, pageSize, search, filter);

export const fetchProvisioningFile = (status, mac) =>
  getHardwareService().fetchProvisioningFile(status, mac);

export const createHardwareFile = (params) =>
  getHardwareService().createHardwareFile(params);

export const deleteHardwareFile = (mac, status) =>
  getHardwareService().deleteHardwareFile(mac, status);
